import { z } from "zod"
import ValidationError from "../error/ValidationError.js"

/**
 * @description
 *	Validates that a given input model matchs the provided schema.
 */
const ValidateOrFail = <S extends z.ZodTypeAny>(schema: S, input: unknown): z.infer<S> => {
	const output = schema.safeParse(input)
	if (output.success) {
		return output.data
	} else {
		throw new ValidationError(output)
	}
}

export default ValidateOrFail
